import { assertInInjectionContext, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { filter, startWith } from 'rxjs';
import { map } from 'rxjs/operators';

export const travelRouterTree$ = <T>(iteratorFn: (route: ActivatedRoute) => T) => {
  assertInInjectionContext(travelRouterTree$);

  const router = inject(Router);
  const route = inject(ActivatedRoute);

  return router.events.pipe(
    startWith(new NavigationEnd(0, router.url, router.url)),
    filter((event) => event instanceof NavigationEnd),
    map(() => route),
    filter(({ outlet }) => outlet === 'primary'),
    map(iteratorFn),
  );
};
